/**
 * Что мутация сообщает общему обработчику уведомлений (queryClient.ts) через meta.
 *
 * По умолчанию отказ любой мутации показывается уведомлением: действие, которое
 * провалилось молча, пользователь не отличит от сработавшего. Мутация, чей экран сам
 * показывает отказ (ошибка формы, диалога, свой тост), объявляет SILENT_ERROR, чтобы
 * сообщение не выходило дважды.
 */

import type { KeyMessage } from '@/utils/displayMessage';

export interface MutationUiMeta extends Record<string, unknown> {
	/** Экран сам показывает отказ этой мутации: общее уведомление не нужно */
	silentError?: true;
	/** Уведомление об успехе действия; без него успех молчит */
	successMessage?: KeyMessage;
}

declare module '@tanstack/react-query' {
	interface Register {
		mutationMeta: MutationUiMeta;
	}
}

/** meta мутации, отказ которой показывает сам экран: общее уведомление не выходит */
export const SILENT_ERROR: MutationUiMeta = { silentError: true };

/** Сообщение об успехе сохранения -- как в макете (workspace-interactions.js:387-391) */
export const SAVED_MESSAGE: KeyMessage = { messageKey: 'common:notifications.saved' };
